/*=====================================
    CheckoutView

    Author: Ac
    CreateTime: 2018 / 09 / 26
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
// import CupoySrefView from 'components/commons/router/CupoySrefView';
import GLOBAL from 'nonnglobal';
import CupoyImage from 'components/commons/CupoyImage';
import productUtil from 'util/productUtil';

/*--------------------------
    Styled
--------------------------*/
const Container = GlobalStyle.BasicBlock.extend`
    margin-bottom: ${GlobalStyle.ViewSpace}px;
    color: ${Colors.Dark3};
`;
const Header = styled.div`
    padding: 0 16px;
    height: 54px;
    line-height: 54px;
    border-bottom: 1px solid #D9D9D9;
    font-size: 20px;
    font-weight: bold;
`;
const Content = styled.div`
    padding: 30px;
`;
const Hint = styled.div`
    &:not(:last-child) {
        margin-bottom: 10px;
    }
`;
const PaymentList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
`;
const PaymentListItem = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    width: 176px;
    height: 196px;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: ${({ isActive }) => isActive ? Colors.MAIN_COLOR : '#D9D9D9'};
    cursor: pointer;

    &:not(:nth-child(5n)) {
        margin-right: 20px;
    }
`;
const PaymentImage = styled.div`
    width: 84px;
    height: 82px;
    background-color: #FFF;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
`;
const PaymentHilifeImage = PaymentImage.extend`
    width: 85px;
`;
const PaymentCardImage = PaymentImage.extend`
    height: 89px;
`;
const PaymentECPayImage = styled(PaymentImage)`
    width: 122px;
    height: 90px;
`;
const PaymentCathyImage = styled(PaymentImage)`
    width: 90px;
    height: 100px;
`;
const PaymentTitle = styled.div`
    color: ${Colors.Dark3};
    font-size: 16px;
    margin-top: 10px;
`;
const PaymentCardTitle = PaymentTitle.extend`
    margin-top: 4px;
`;
const ManualBtn = GlobalStyle.BasicBtn.extend`
    width: 64px;
    height: 24px;
    font-size: 14px;
    margin-top: 9px;
`;
const FooterHeader = Header.extend`
    padding: 0 30px;
`;
const FooterContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 22px 16px 30px;
    font-size: 14px;
    color: ${Colors.Dark3};
`;
const PriceNumber = styled.span`
    font-size: 26px;
`;
const Price = styled.div`
    font-size: 14px;
    font-weight: bold;
    margin-left: 8px;
    color: ${Colors.MAIN_COLOR};
`;
const AddOrderBtn = GlobalStyle.BasicBtn.extend`
    width: 145px;
    height: 46px;
    margin-left: auto;
`;
const BtnLoading = GlobalStyle.Spin.extend`
    border-right-color: #FFF;
    border-bottom-color: #FFF;
    margin: 0 6px;
`;
// const PaymentDescription = styled.div`
//     position: relative;
//     border-radius: 5px;
//     border: 1px solid ${Colors.MAIN_COLOR};
//     margin-top: 45px;
//     padding: 30px;
// `;
/*--------------------------
    Main Component
--------------------------*/
class CheckoutView extends Component {

    // static propTypes = {
    // };

    constructor(props) {
        super(props);

        this.initCartItems = this.initCartItems.bind(this);
        this.initVitemCartOrder = this.initVitemCartOrder.bind(this);
        this.changePaytype = this.changePaytype.bind(this);
        this.changePaytypeToEsun = this.changePaytype.bind(this, GLOBAL.PAYTYPE.ESUN);
        this.changePaytypeToIbon = this.changePaytype.bind(this, GLOBAL.PAYTYPE.IBON);
        this.changePaytypeToFamiport = this.changePaytype.bind(this, GLOBAL.PAYTYPE.FAMIPORT);
        this.changePaytypeToHilife = this.changePaytype.bind(this, GLOBAL.PAYTYPE.HILIFE);
        this.changePaytypeToAllpayCreditcard = this.changePaytype.bind(this, GLOBAL.PAYTYPE.ALLPAY_CREDITCARD);
        this.changePaytypeToECPay = this.changePaytype.bind(this, GLOBAL.PAYTYPE.ECPAYATM);
        this.changePaytypeToCathy = this.changePaytype.bind(this, GLOBAL.PAYTYPE.CATHYATM);
        this.payCardCart = this.payCardCart.bind(this);

        this.state = {
            paytype: null,
            isEmpty: false,
            isLoading: true,
            isPaying: false,
            price: 0,
            isFromCart: true,
            allowIbon: false,
            allowFami: false,
            allowHilife: false,
            allowAllpay: false,
            isChecked: false,
            minfoisLoading : false,
        };
    }

    componentDidMount() {

        window.scrollTo({ top: 0 });

        const current = CupoyRouter.getCurrent();
        const statename = current.state.name;
        let isFromCart = false;
        const minfolastupdtime =  this.props.minfolastupdtime;


        if(statename === CupoyRouter.STATES.MEMBER_CHECKOUT) {
            isFromCart = true;
        }

        this.setState({
            isFromCart,
        }, () => {
            if(isFromCart) {
                this.props.cardCartActions.listCardCartItems().then(()=>{
                    this.initCartItems();
                });
            } else {
                this.initVitemCartOrder();
            }
        });
        const now = new Date();
        const timeinterval = now - minfolastupdtime;
        console.log('now ' + now + ' minfolastupdtime ' + minfolastupdtime +' timeinterval ' + timeinterval + " 10min " + 10 * 60 * 1000)
        if(timeinterval > 10 * 60 * 1000){
            this.setState({minfoisLoading : true});
            this.props.memberActions.getMemberPageMetrics().then(()=>{
                    console.log("update memberinfo");
                    this.setState({minfoisLoading : false});
               });;

        }
        else 
            this.setState({minfoisLoading : false});

    }

    calcGridItemWidth = (width, count, gap) => Number.parseInt((width - ((count - 1) * gap)) / count, 10);

    checkWebState = () => {

        this.props.webActions.checkWebState(
        ).then(()=> {
            
            const {
                CATHYATM,
                ESUNATM,
                FAMIPORT,
                LIFEET,
                ECPAY,
            } = this.props;

            const {
                allowFami,
                allowHilife,
            } = this.state;

            // 檢查完後將付款方式選到預設第一筆 (Ibon後面還會判斷，不用管)
            let paytype = null;
            if (ESUNATM) {
                paytype = GLOBAL.PAYTYPE.ESUN;
            } else if (CATHYATM) {
                paytype = GLOBAL.PAYTYPE.CATHYATM;
            } else if (allowFami && FAMIPORT) {
                paytype = GLOBAL.PAYTYPE.FAMIPORT;
            } else if (allowHilife && LIFEET) {
                paytype = GLOBAL.PAYTYPE.HILIFE;
            } /*else if (allowAllpay && isFromCart && ALLPAY) {
                paytype = GLOBAL.PAYTYPE.ALLPAY_CREDITCARD;
            }*/ else if (ECPAY) {
                paytype = GLOBAL.PAYTYPE.ECPAYATM;
            }

            this.setState({
                isChecked: true,
                paytype,
            }, () => {
                this.checkAllowIbon();
                this.checkAllowAllpay();
            });
        });
    }

    checkAllowIbon = () => {

        const {
            IBON,
            cartItems = [],
        } = this.props;

        const {
            price,
        } = this.state;

        // 後台沒有開放IBON，不繼續做下一步檢查
        if (!IBON) {
            return;
        }

        // 購物車商品總價不符合ibon繳費範圍，不繼續做下一步檢查
        if (price < 100 || price > 10000) {
            return;
        }

        // 檢查購物車商品是否有除了虛寶包以外的商品，有的話不開放ibon
        const hadOtherPdt = cartItems.reduce((result, item) => 
            result ? result : item.productclassid !== productUtil.PRODUCT_TYPE.VITEM
            , false
        );
        
        // 有除了虛寶包以外的商品，不繼續做下一步檢查
        if (hadOtherPdt) {
            return;
        }

        // 檢查ibon黑名單
        this.props.cardActions.getIbonBlacklist().then(result => {

            const hadBlockPdt = cartItems.reduce((acc, item) =>
                acc ? acc : result.includes(item.jsdproductid)
                , false
            );

            // 沒有商品在黑名單內，開啟ibon選項
            if (!hadBlockPdt) {
                this.setState(prevState => {
                    return ({
                        // 其他金流都關閉的話不會付款方式不會有預設值，這邊就幫他自動選取到 ibon
                        paytype: prevState.paytype ?? GLOBAL.PAYTYPE.IBON,
                        allowIbon: true,
                    })
                });
            }
        });
    }
    checkAllowAllpay = () => {
        
        const {
            ALLPAY,
            memberinfo,
        } = this.props;

        const {
            price,
            isFromCart
        } = this.state;
        // 後台沒有開放信用卡，不繼續做下一步檢查
        if (!ALLPAY) {
            return;
        }
        // 購物車商品總價不符合信用卡繳費範圍，不繼續做下一步檢查
        if (price <= 0 || price > 10000) {
            return;
        }
        /**
         * #905
         * 信用卡新規則
         * ■ 新會員30天內不能使用信用卡。
         * ■ 會員每日信用卡購買上限1萬元整(淩晨00:00點重置額度)。
         * ■ 購物車金額1~10000元才顯示信用卡選項
         */
        
        while (!this.state.minfoisLoading){
        // 註冊未超過30天不符合信用卡繳費範圍，不繼續做下一步檢查
            var after30days = parseInt(memberinfo.registertime) + 2592000000;
            if(after30days > Date.now()){
                return;
            }
            // 
            break;
        }

        this.setState(prevState => {
            return ({
                // 其他金流都關閉的話不會付款方式不會有預設值，這邊就幫他自動選取到 ibon
                paytype: prevState.paytype ?? GLOBAL.PAYTYPE.ALLPAY_CREDITCARD,
                allowAllpay: true,
            })
        });

    }
    initCartItems() {

        const cartItems = this.props.cartItems;

        if(!Array.isArray(cartItems) || cartItems.length === 0) {
            this.setState({
                isEmpty: true,
                isLoading: false,
            });
        } else {

            let price = 0;

            for(let i = 0; i < cartItems.length; i++) {
                price += cartItems[i].memberprice * cartItems[i].count;
            }

            const allowFami = price >= 100 && price <= 5000;
            const allowHilife = price >= 100 && price <= 10000;
            this.setState({
                price,
                isLoading: false,
                allowFami,
                allowHilife,
            }, () => {
                // check後台金流開放狀態
                this.checkWebState();
            });
        }
    }

    initVitemCartOrder() {

        const {
            vitemCartOrder,
        } = this.props;

        if(!vitemCartOrder || !vitemCartOrder[0] || !vitemCartOrder[0].totalamount) {
            this.setState({
                isEmpty: true,
                isLoading: false,
            });
        } else {

            const price = vitemCartOrder[0].totalamount;
            const allowFami = price >= 100 && price <= 5000;
            const allowHilife = price >= 100 && price <= 10000;
            const { gamename = '', gameid } = vitemCartOrder[0];

            this.props.handleGameData(gamename, gameid);

            this.setState({
                price,
                isLoading: false,
                allowFami,
                allowHilife,
            }, () => {
                this.checkWebState();
            });
        }
    }

    changePaytype(paytype) {

        if(paytype === this.state.paytype)
            return;

        this.setState({
            paytype,
        })
    }

    payCardCart() {

        const {
            paytype,
            isPaying,
            isFromCart,
        } = this.state;

        if(isPaying || !paytype) {
            return null;
        }

        this.setState({
            isPaying: true,
        }, () => {

            if(isFromCart) {
                this.props.cardCartActions.payCardCart({
                    paytype,
                }).then(result => {

                    // if(result.paytype === GLOBAL.PAYTYPE.ALLPAY_CREDITCARD && result.allpaycheckoutstruct) {
                    //     this.props.webActions.payByCreditCard(result.allpaycheckoutstruct);
                    // } else {
                        // 更新未付款購物車列表
                        this.props.cardCartActions.listCardCartUnfinishedOrders({
                            start: 0,
                            refresh: true,
                        });
                        this.props.cardCartActions.listCardCartItems();
                        this.props.webActions.cupoyStateGo(CupoyRouter.STATES.MEMBER_CARD_ORDER_UNPAY_DETAIL, {
                            cartid: result.cartid,
                        })
                    // }

                }, error => {
                    var errorMsg = '發生無法預期的錯誤';
                    var errorDescription = '';

                    if(error && error.code) {
                        errorMsg = error.message;
                    }

                    this.props.webActions.openAlertDialog({
                        title: errorMsg,
                        description: errorDescription,
                    });

                    this.setState({
                        isPaying: false,
                    });
                })
            } else {
                this.props.vitemActions.payVItemCart({
                    paytype,
                }).then(result => {

                    // if(result.paytype === GLOBAL.PAYTYPE.ALLPAY_CREDITCARD && result.allpaycheckoutstruct) {
                    //     this.props.webActions.payByCreditCard(result.allpaycheckoutstruct);
                    // } else {
                        this.props.webActions.cupoyStateGo(CupoyRouter.STATES.MEMBER_CART_PAYMENT_INFO, {
                            id: result.cartid,
                        })
                    // }

                }, error => {
                    var errorMsg = '發生無法預期的錯誤';
                    var errorDescription = '';

                    if(error && error.code) {
                        errorMsg = error.message;
                    }

                    this.props.webActions.openAlertDialog({
                        title: errorMsg,
                        description: errorDescription,
                    });

                    this.setState({
                        isPaying: false,
                    });
                })
            }
        })
    }

    // ### 9199人員要求直接連到/help/transaction_order繳費說明 by Ac.
    // showHowToPayment = paytype => {
    //     // <p style="color: red"></p>
    //     switch (paytype) {
    //         // ATM
    //         case GLOBAL.PAYTYPE.ESUN:
    //         case GLOBAL.PAYTYPE.MEGA:
    //         case GLOBAL.PAYTYPE.ALLPAY_BANK:
    //         case GLOBAL.PAYTYPE.ECPAYATM:
    //         case GLOBAL.PAYTYPE.CATHYATM:
    //             this.props.webActions.openAlertDialog({
    //                 title: 'ATM付款說明',
    //                 descriptionHTML: '<p style="color: red">重要提醒 : \n■ 繳費前請先確認您的【訂單虛擬帳號】，是否正確，避免繳錯帳戶被系統卡款導致無法購買。\n■ 轉帳限額為各家銀行之規定，非本公司之規定；若您欲提高轉帳限額，請致電各銀行申請。</p>'
    //             }); 
    //             return;
    //         // 信用卡
    //         case GLOBAL.PAYTYPE.ALLPAY_CREDITCARD:
    //             this.props.webActions.openAlertDialog({
    //                 title: '信用卡付款說明',
    //                 descriptionHTML: `
    //                 <p>■ 新會員30天內不能使用信用卡。\n■ 半年內使用其他付款方式繳費未超過5,000元，不能使用信用卡付款。\n■ 正式會員24小時內信用卡購買上限1萬元整。\n■ 產生本付款訂單後，請於${GLOBAL.PAYMENT_LIMIT_HOUR_TEXT}內完成付款(逾期失效)。\n■ 信用卡服務僅限於購買點數卡、產品包類商品，道具卡未開放。\n■ 信用卡手續費以消費金額上限2.5%計算，若未滿5元將以5元收取。</p>
    //                 <p style="color: red;">需有3D發卡行的信用卡才可使用 : </p>
    //                 <p>國泰世華商業銀行、永豐商業銀行、聯邦商業銀行、台灣新光商業銀行、第一商業銀行、華南商業銀行、兆豐國際商業銀行、合作金庫商業銀行、渣打國際商業銀行、台灣中小企業銀行、彰化商業銀行、日盛國際商業銀行、台灣銀行、台灣永旺信用卡(股)公司、台灣土地銀行、台新銀行、上海商業儲蓄銀行、中國信託、富邦銀行。</p>
    //                 `
    //             }); 
    //             return;
    //         // 全家
    //         case GLOBAL.PAYTYPE.FAMIPORT:
    //             this.props.webActions.openAlertDialog({
    //                 title: '全家付款流程',
    //                 imageUrl: 'images/howto_payment/famiport_howto.jpg'
    //             }); 
    //             return;
    //         // 7-11
    //         case GLOBAL.PAYTYPE.IBON:
    //             this.props.webActions.openAlertDialog({
    //                 title: 'iBon付款說明',
    //                 imageUrl: 'images/howto_payment/ibon_howto.jpg'
    //             }); 
    //             return;
    //         // 萊爾富
    //         case GLOBAL.PAYTYPE.HILIFE:
    //             this.props.webActions.openAlertDialog({
    //                 title: '萊爾富付款流程',
    //                 imageUrl: 'images/howto_payment/hilife_howto.jpg'
    //             }); 
    //             return;
    //         default:
    //             return;
    //     }
    // }

    render() {

        const {
            haslogin,
        } = this.props;

        const {
            isLoading,
            isEmpty,
        } = this.state;

        let content;

        if(haslogin) {
            content = this.renderLoginContent();
        } else {
            content = this.renderNoLoginContent();
        }

        return (
            <Fragment>
                <Container>
                    <Header>選擇付款方式</Header>
                    {content}
                </Container>
                {!isLoading && !isEmpty && this.renderFooter()}
            </Fragment>
        );
    }

    renderLoginContent = () => {

        const {
            isLoading,
            isEmpty,
            isChecked,
        } = this.state;

        return (
            <Fragment>

                {!isLoading && !isEmpty && isChecked && this.renderContent()}

                {(isLoading || !isChecked) && !isEmpty && (
                    <GlobalStyle.LoadingContainer>
                        <GlobalStyle.Spin/>
                    </GlobalStyle.LoadingContainer>
                )}

                {isEmpty && (
                    <GlobalStyle.ErrorContainer>
                        <GlobalStyle.ErrorContainerTitle>
                            尚無商品，無法結帳
                        </GlobalStyle.ErrorContainerTitle>
                    </GlobalStyle.ErrorContainer>
                )}

            </Fragment>
        );
    }

    renderContent = () => {

        const {
            paytype,
            isFromCart,
            allowIbon,
            allowFami,
            allowHilife,
            allowAllpay,
        } = this.state;

        const {
            ESUNATM,
            CATHYATM,
            LIFEET,
            ALLPAY,
            ECPAY,
            FAMIPORT,
        } = this.props;

        return (
            <Content>
                <Hint>{`1. 訂單繳款期限${GLOBAL.PAYMENT_LIMIT_HOUR_TEXT}(逾期失敗) `}</Hint>
                <Hint>2.若繳費金額錯誤，無法出貨只能退費</Hint>

                <PaymentList>
                    {
                        ESUNATM && (
                            <PaymentListItem
                                onClick={this.changePaytypeToEsun}
                                isActive={paytype === GLOBAL.PAYTYPE.ESUN}
                            >
                                <CupoyImage
                                    src='images/payment_images/payment_esun.jpg'
                                    stylecomponent={PaymentImage}
                                    isBackgroundImage
                                />
                                <PaymentTitle>
                                    {GLOBAL.PAYTYPE_STRING[GLOBAL.PAYTYPE.ESUN]}
                                </PaymentTitle>
                                <a href={`/help/transaction_order?paymentType=${GLOBAL.PAYTYPE.ESUN}`} target="_blank" rel="noopener noreferrer">
                                    <ManualBtn>說明</ManualBtn>
                                </a>
                            </PaymentListItem>
                        )
                    }
                    {
                        CATHYATM && (
                            <PaymentListItem
                                onClick={this.changePaytypeToCathy}
                                isActive={paytype === GLOBAL.PAYTYPE.CATHYATM}
                            >
                                <CupoyImage
                                    src='images/payment_images/payment_cathy.jpg'
                                    stylecomponent={PaymentCathyImage}
                                    isBackgroundImage
                                />
                                <PaymentTitle>
                                    {GLOBAL.PAYTYPE_STRING[GLOBAL.PAYTYPE.CATHYATM]}
                                </PaymentTitle>
                                <a href={`/help/transaction_order?paymentType=${GLOBAL.PAYTYPE.CATHYATM}`} target="_blank" rel="noopener noreferrer">
                                    <ManualBtn>說明</ManualBtn>
                                </a>
                            </PaymentListItem>
                        )
                    }
                    {
                        allowHilife && LIFEET && (
                            <PaymentListItem
                                onClick={this.changePaytypeToHilife}
                                isActive={paytype === GLOBAL.PAYTYPE.HILIFE}
                            >
                                <CupoyImage
                                    src='images/payment_images/payment_hilife.jpg'
                                    stylecomponent={PaymentHilifeImage}
                                    isBackgroundImage
                                />
                                <PaymentTitle>
                                    {GLOBAL.PAYTYPE_STRING[GLOBAL.PAYTYPE.HILIFE]}
                                </PaymentTitle>
                                <a href={`/help/transaction_order?paymentType=${GLOBAL.PAYTYPE.HILIFE}`} target="_blank" rel="noopener noreferrer">
                                    <ManualBtn>說明</ManualBtn>
                                </a>
                            </PaymentListItem>
                        )
                    }
                    {
                        allowIbon ?
                        <PaymentListItem
                            onClick={this.changePaytypeToIbon}
                            isActive={paytype === GLOBAL.PAYTYPE.IBON}
                        >
                            <CupoyImage
                                src='images/payment_images/payment_ibon.png'
                                stylecomponent={PaymentImage}
                                isBackgroundImage
                            />
                            <PaymentTitle>
                                {GLOBAL.PAYTYPE_STRING[GLOBAL.PAYTYPE.IBON]}
                            </PaymentTitle>
                            <a href={`/help/transaction_order?paymentType=${GLOBAL.PAYTYPE.IBON}`} target="_blank" rel="noopener noreferrer">
                                <ManualBtn>說明</ManualBtn>
                            </a>
                        </PaymentListItem>
                        :
                        null
                    }
                    {
                        allowFami && FAMIPORT && (
                            <PaymentListItem
                                onClick={this.changePaytypeToFamiport}
                                isActive={paytype === GLOBAL.PAYTYPE.FAMIPORT}
                            >
                                <CupoyImage
                                    src='images/payment_images/payment_famiport.jpg'
                                    stylecomponent={PaymentImage}
                                    isBackgroundImage
                                />
                                <PaymentTitle>
                                    {GLOBAL.PAYTYPE_STRING[GLOBAL.PAYTYPE.FAMIPORT]}
                                </PaymentTitle>
                                <a href={`/help/transaction_order?paymentType=${GLOBAL.PAYTYPE.FAMIPORT}`} target="_blank" rel="noopener noreferrer">
                                    <ManualBtn>說明</ManualBtn>
                                </a>
                            </PaymentListItem>
                        )
                    }
                    {
                        allowAllpay ? 
                            <PaymentListItem
                                onClick={this.changePaytypeToAllpayCreditcard}
                                isActive={paytype === GLOBAL.PAYTYPE.ALLPAY_CREDITCARD}
                            >
                                <CupoyImage
                                    src='images/payment_images/payment_creditcard.jpg'
                                    stylecomponent={PaymentCardImage}
                                    isBackgroundImage
                                />
                                <PaymentCardTitle>
                                    {GLOBAL.PAYTYPE_STRING[GLOBAL.PAYTYPE.ALLPAY_CREDITCARD]}
                                </PaymentCardTitle>
                                <a href={`/help/transaction_order?paymentType=${GLOBAL.PAYTYPE.ALLPAY_CREDITCARD}`} target="_blank" rel="noopener noreferrer">
                                    <ManualBtn>說明</ManualBtn>
                                </a>
                            </PaymentListItem>
                        :
                        null
                    }
                    {
                        ECPAY && (
                            <PaymentListItem
                                onClick={this.changePaytypeToECPay}
                                isActive={paytype === GLOBAL.PAYTYPE.ECPAYATM}
                            >
                                <CupoyImage
                                    src='images/payment_images/payment_ecpay.png'
                                    stylecomponent={PaymentECPayImage}
                                    isBackgroundImage
                                />
                                <PaymentCardTitle>
                                    {GLOBAL.PAYTYPE_STRING[GLOBAL.PAYTYPE.ECPAYATM]}
                                </PaymentCardTitle>
                                <a href={`/help/transaction_order?paymentType=${GLOBAL.PAYTYPE.ECPAYATM}`} target="_blank" rel="noopener noreferrer">
                                    <ManualBtn>說明</ManualBtn>
                                </a>
                            </PaymentListItem>
                        )
                    }
                </PaymentList>
                
            </Content>
        );
    }

    renderFooter = () => {

        const {
            price,
            isPaying,
            paytype,
        } = this.state;

        return (
            <Container>
                <FooterHeader>
                    結帳
                </FooterHeader>
                <FooterContent>
                    總價：
                    <Price>
                        <PriceNumber>
                            {price}
                        </PriceNumber>
                        {` 元 `}
                    </Price>
                    <AddOrderBtn
                        onClick={this.payCardCart}
                        disable={isPaying || !paytype}
                    >
                        {isPaying && <BtnLoading />}
                        下一步
                    </AddOrderBtn>
                </FooterContent>
            </Container>
        );
    }

    renderNoLoginContent = () => {
        return (
            <Container>
                <GlobalStyle.ErrorContainer>
                    <GlobalStyle.ErrorContainerTitle>您尚未登入</GlobalStyle.ErrorContainerTitle>
                    <GlobalStyle.ErrorContainerDesription>您尚未登入，請登入後再重新操作一次。</GlobalStyle.ErrorContainerDesription>
                </GlobalStyle.ErrorContainer>
            </Container>
        );
    }

}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        haslogin: state.member.haslogin,
        cartItems: state.cardcart.cartItems,
        vitemCartOrder: state.vitem.cartOrder,
        memberinfo: state.member.memberinfo,
        minfolastupdtime : state.member.minfolastupdtime,
        ESUNATM: state.web.ESUNATM,
        CATHYATM: state.web.CATHYATM,
        LIFEET: state.web.LIFEET,
        ALLPAY: state.web.ALLPAY,
        ECPAY: state.web.ECPAY,
        IBON: state.web.IBON,
        FAMIPORT: state.web.FAMIPORT,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        cardActions: bindActionCreators(actionCreators.cardActionCreators, dispatch),
        cardCartActions: bindActionCreators(actionCreators.cardCartActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        vitemActions: bindActionCreators(actionCreators.vitemActionCreators, dispatch),
        memberActions: bindActionCreators(actionCreators.memberActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(CheckoutView);
